import { Trans, useLingui } from '@lingui/react/macro'
import { BarChart } from '@mantine/charts'
import '@mantine/charts/styles.css'
import { Card, Stack, Text } from '@mantine/core'
import { MonthlyData } from './utils'

interface CostsMonthlyChartProps {
  data: MonthlyData[]
}

export function CostsMonthlyChart({ data }: CostsMonthlyChartProps) {
  const { t } = useLingui()
  return (
    <Card withBorder radius="lg" p="md">
      <Stack gap="md">
        <Text fw={600} size="sm">
          <Trans>Monthly costs</Trans>
        </Text>

        <BarChart
          h={300}
          w="100%"
          data={data}
          dataKey="month"
          series={[
            { name: 'budget', label: t`Budgeted`, color: 'blue.4' },
            { name: 'actual', label: t`Actual`, color: 'orange.6' },
          ]}
          tickLine="y"
          gridAxis="y"
          withLegend
          legendProps={{ verticalAlign: 'bottom', height: 50 }}
          valueFormatter={(value) => `${value.toFixed(2)} €`}
        />
      </Stack>
    </Card>
  )
}
